/* istanbul ignore file */
/**
 * This client was automatically generated by RudderTyper. ** Do Not Edit **
 */
/**
 * The default handler that is fired if none is supplied with setRudderTyperOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler = (message, violations) => {
  const msg = JSON.stringify(
    {
      type: 'RudderTyper JSON Schema Validation Error',
      description:
        `You made an analytics call (${message.event}) using RudderTyper that doesn't match the ` +
        'Tracking Plan spec.',
      errors: violations,
    },
    undefined,
    2
  );
  console.warn(msg);
};
let analytics = () => {
  return window.analytics;
};
/**
 * Updates the run-time configuration of this RudderTyper client.
 *
 * @param {RudderTyperOptions} options - the options to upsert
 *
 * @typedef {Object} RudderTyperOptions
 * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setRudderTyperOptions(options) {
  analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
}
/**
 * Helper to attach metadata on RudderTyper to outbound requests.
 * This is used for attribution and debugging by the RudderStack team.
 */
function withRudderTyperContext(message = {}) {
  return {
    ...message,
    context: {
      ...(message.context || {}),
      ruddertyper: {
        sdk: 'analytics.js',
        language: 'javascript',
        rudderTyperVersion: '1.0.0-beta.5',
        trackingPlanId: 'tp_1uZ45DFhpGdImHhzH0baIm3XHCJ',
        trackingPlanVersion: '69',
      },
    },
  };
}
/**
 * @typedef ProductClickedProductsItem
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 */
/**
 * @typedef ProductClicked
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} collection_parent -
 * @property {string} collection_type -
 * @property {string} [collection_url] -
 * @property {string} currency -
 * @property {string} currency_symbol -
 * @property {ProductClickedProductsItem[]} products -
 */
/**
 * @typedef ProductViewed
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {boolean} [initial_load] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductAddedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductAdded
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {ProductAddedProductsItem[]} [products] -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductRemovedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductRemoved
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {ProductRemovedProductsItem[]} [products] -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CartViewedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CartViewed
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {CartViewedProductsItem[]} products -
 */
/**
 * @typedef ProductListFilteredFiltersItem
 * @property {string} type -
 * @property {string} value -
 */
/**
 * @typedef ProductListFilteredProductsItem
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 */
/**
 * @typedef ProductListFilteredSortsItem
 * @property {string} type -
 * @property {string} value -
 */
/**
 * @typedef ProductListFiltered
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} collection_parent -
 * @property {string} collection_type -
 * @property {string} [collection_url] -
 * @property {string} currency -
 * @property {string} currency_symbol -
 * @property {ProductListFilteredFiltersItem[]} [filters] -
 * @property {boolean} [is_markdown_collection] -
 * @property {string} list_id -
 * @property {ProductListFilteredProductsItem[]} products -
 * @property {ProductListFilteredSortsItem[]} [sorts] -
 */
/**
 * @typedef CheckoutStartedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStarted
 * @property {string} checkout_id -
 * @property {string} checkout_url -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} [order_id] -
 * @property {CheckoutStartedProductsItem[]} products -
 * @property {number} [total] -
 * @property {string} [type] -
 */
/**
 * @typedef OrderCompletedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} [variant_id] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef OrderCompleted
 * @property {number} [campaignId] -
 * @property {string} [checkout_id] -
 * @property {string} [checkout_url] -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} order_id -
 * @property {string} [order_name] -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {OrderCompletedProductsItem[]} products -
 * @property {number} [shipping] -
 * @property {string} [shipping_method] -
 * @property {number} [subtotal] -
 * @property {number} [tax] -
 * @property {number} [templateId] -
 * @property {number} [total] -
 * @property {string} [type] -
 */
/**
 * @typedef CheckoutStepViewedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStepViewed
 * @property {string} checkout_id -
 * @property {string} [checkout_url] -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {CheckoutStepViewedProductsItem[]} [products] -
 * @property {number} [shipping] -
 * @property {string} [shipping_method] -
 * @property {number} [step] -
 * @property {string} step_name -
 * @property {number} [subtotal] -
 * @property {number} [tax] -
 * @property {number} [total] -
 * @property {string} [type] -
 */
/**
 * @typedef CheckoutStepCompletedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStepCompleted
 * @property {string} checkout_id -
 * @property {string} [checkout_url] -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {CheckoutStepCompletedProductsItem[]} [products] -
 * @property {number} [shipping] -
 * @property {string} [shipping_method] -
 * @property {number} [step] -
 * @property {string} step_name -
 * @property {number} [subtotal] -
 * @property {number} [tax] -
 * @property {number} [total] -
 * @property {string} [type] -
 */
/**
 * @typedef CheckoutFailureProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutFailure
 * @property {string} checkout_id -
 * @property {string} [checkout_url] -
 * @property {string} failure_reason -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {CheckoutFailureProductsItem[]} [products] -
 * @property {string} [shipping_method] -
 * @property {string} [type] -
 */
/**
 * @typedef ProductListViewedProductsItem
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductListViewed
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} collection_parent -
 * @property {number} collection_style_count -
 * @property {string} collection_type -
 * @property {string} [collection_url] -
 * @property {string} currency -
 * @property {string} currency_symbol -
 * @property {boolean} [is_markdown_collection] -
 * @property {string} list_id -
 * @property {ProductListViewedProductsItem[]} products -
 */
/**
 * @typedef ProductShared
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [share_via] -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductsSearched
 * @property {string} query -
 */
/**
 * @typedef UserMarketingPreference
 * @property {string} [cms_product_id] -
 * @property {string} message_medium -
 * @property {string} message_type -
 * @property {boolean} opt_in_status -
 * @property {string} placement -
 * @property {string} [purpose] -
 * @property {string} [sku] -
 */
/**
 * @typedef ExperimentViewed
 * @property {string} campaign_id -
 * @property {string} campaign_name -
 * @property {string} experience_id -
 * @property {string} experience_name -
 * @property {string} experiment_type -
 * @property {string} variation_id -
 * @property {string} variation_name -
 * @property {string} [web_platform] -
 */
/**
 * User clicked on a product
 *
 * @param {ProductClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed a product details
 *
 * @param {ProductViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User added a product to their shopping cart
 *
 * @param {ProductAdded} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productAdded(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Added', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User removed a product from their shopping cart
 *
 * @param {ProductRemoved} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productRemoved(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Removed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed their shopping cart
 *
 * @param {CartViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function cartViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Cart Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User filtered a collection
 *
 * @param {ProductListFiltered} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productListFiltered(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product List Filtered', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User initiated the order process (a transaction is created)
 *
 * @param {CheckoutStarted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStarted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Started', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User completed the order
 *
 * @param {OrderCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function orderCompleted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Order Completed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed a checkout step
 *
 * @param {CheckoutStepViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStepViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Step Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User completed a checkout step
 *
 * @param {CheckoutStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStepCompleted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Step Completed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User hit a failure scenario during checkout
 *
 * @param {CheckoutFailure} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutFailure(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Failure', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed a collection
 *
 * @param {ProductListViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productListViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product List Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * Shared a product with one or more friends
 *
 * @param {ProductShared} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productShared(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Shared', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User did a text search for products
 *
 * @param {ProductsSearched} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productsSearched(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Products Searched', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User preferences for opting into/out marketing messages
 *
 * @param {UserMarketingPreference} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userMarketingPreference(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('User Marketing Preference', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User views an experiment on a page
 *
 * @param {ExperimentViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function experimentViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Experiment Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
const clientAPI = {
  /**
   * Updates the run-time configuration of this RudderTyper client.
   *
   * @param {RudderTyperOptions} options - the options to upsert
   *
   * @typedef {Object} RudderTyperOptions
   * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setRudderTyperOptions,
  /**
   * User clicked on a product
   *
   * @param {ProductClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productClicked,
  /**
   * User viewed a product details
   *
   * @param {ProductViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productViewed,
  /**
   * User added a product to their shopping cart
   *
   * @param {ProductAdded} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productAdded,
  /**
   * User removed a product from their shopping cart
   *
   * @param {ProductRemoved} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productRemoved,
  /**
   * User viewed their shopping cart
   *
   * @param {CartViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  cartViewed,
  /**
   * User filtered a collection
   *
   * @param {ProductListFiltered} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productListFiltered,
  /**
   * User initiated the order process (a transaction is created)
   *
   * @param {CheckoutStarted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutStarted,
  /**
   * User completed the order
   *
   * @param {OrderCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  orderCompleted,
  /**
   * User viewed a checkout step
   *
   * @param {CheckoutStepViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutStepViewed,
  /**
   * User completed a checkout step
   *
   * @param {CheckoutStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutStepCompleted,
  /**
   * User hit a failure scenario during checkout
   *
   * @param {CheckoutFailure} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutFailure,
  /**
   * User viewed a collection
   *
   * @param {ProductListViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productListViewed,
  /**
   * Shared a product with one or more friends
   *
   * @param {ProductShared} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productShared,
  /**
   * User did a text search for products
   *
   * @param {ProductsSearched} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productsSearched,
  /**
   * User preferences for opting into/out marketing messages
   *
   * @param {UserMarketingPreference} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  userMarketingPreference,
  /**
   * User views an experiment on a page
   *
   * @param {ExperimentViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  experimentViewed,
};
export default new Proxy(clientAPI, {
  get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }
    return () => {
      console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
    a) Re-generate your ruddertyper client: \`npx rudder-typer\`
    b) Add it to your Tracking Plan: https://api.rudderstack.com/trackingplans/tp_1uZ45DFhpGdImHhzH0baIm3XHCJ`);
      const a = analytics();
      if (a) {
        a.track(
          'Unknown Analytics Call Fired',
          {
            method,
          },
          withRudderTyperContext()
        );
      }
    };
  },
});
